// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3T8rv","item":"PaymentsMobile_item__19zMN","label":"PaymentsMobile_label__3g7ov","amount":"PaymentsMobile_amount__ARh9V"};